import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import styles from "./reportTemplate.module.scss";
import { useResize } from "ecom-teams-apps-core";
import { Flex, Header, Text } from "@fluentui/react-northstar";
import { constants } from "shared/constants";

export interface ReportTemplateProps {
    header: string;
    subtitle1: string | undefined;
    subtitle2?: string | undefined;
    mineSection: React.ReactNode | null;
    summarySection?: React.ReactNode | null;
    tableHeader: string;
    tableFilteringSection?: React.ReactNode | null;
    tableSection: React.ReactNode | null;
}

const ReportTemplate: React.FC<ReportTemplateProps> = observer((props: ReportTemplateProps) => {
    const windowRef = useRef(document.body);
    const [windowWidth] = useResize(windowRef);
    const isMobile = windowWidth < constants.mediumDeviceWidthPx;

    const shouldShowCompanySection = (): boolean => {
        return props.mineSection !== null;
    };

    const shouldShowReportsTableSection = (): boolean => {
        return props.tableSection !== null;
    };

    return (
        <Flex column gap="gap.medium">
            {shouldShowCompanySection() && (
                <>
                    <Header
                        as="h2"
                        content={props.header}
                        className={styles.header}
                        style={isMobile ? { marginTop: 0 } : {}}
                    />
                    <Flex column gap="gap.smaller">
                        <Text weight="regular" size="medium">
                            {props.subtitle1}
                        </Text>
                        {props.subtitle2 && (
                            <Text weight="regular" size="medium" style={{ marginTop: "-10px" }}>
                                {props.subtitle2}
                            </Text>
                        )}
                    </Flex>
                    <div className={styles.userTargetReportWrapper}>{props.mineSection}</div>
                </>
            )}
            {props.summarySection && <div className={styles.userTargetReportWrapper}>{props.summarySection}</div>}
            {shouldShowReportsTableSection() && (
                <>
                    <Header as="h2" content={props.tableHeader} />
                    {props.tableFilteringSection && props.tableFilteringSection}
                    {props.tableSection}
                </>
            )}
        </Flex>
    );
});

export default ReportTemplate;
